export default __webpack_public_path__ + "static/Bildschirmfoto-2019-11-08-um-15.39.08-9dada426128347093f5f538fef26643e.jpg";